import type { FaireProductEntity } from "../../entity_types/product";

export const p_kwj77tt9yp: FaireProductEntity = {
  token: "p_kwj77tt9yp",
  type: "product",
  name: "Orleans 18K Gold Non-Tarnish Layered V Rhinestone Ring",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/dc5b7c1af516b2eb1f250b9edb4c7e9956f8a0bf6292fa913e02e36c04a1356d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0ea082cc76d59a5a8a6b40fb724d012ba603c0ca17f5595ccc55b12bda9a88c8.jpeg",
    "https://cdn.faire.com/fastly/c39f79699ed2502bcb4424d3a3c21f060e4f4e13d4b90df768db605325427124.jpeg",
    "https://cdn.faire.com/fastly/72c1ac138a3e0f8f489d2a7e7514b11784806d9b94a8ed878854213c9550b6fc.jpeg",
  ],
  priceDollars: 9.53,
  description:
    "18K Gold Non-Tarnish Layered V Rhinestone Ring\n18K Gold Plating\nStainless Steel\nRhinestone\nSize 7 Measurement: 0.682 Diameter/2.14 Circumference\nSize 8 Measurement: 0.714 Diameter/2.24 Circumference\n \n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:57.878Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
